import { render, staticRenderFns } from "./VerifyPhoneDialog.vue?vue&type=template&id=381f7074&"
import script from "./VerifyPhoneDialog.vue?vue&type=script&lang=js&"
export * from "./VerifyPhoneDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports